"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactComponents = require("@ui-propulsion/react-components");
var _util = require("../../../util");
var _excluded = ["className"];
(function () {
  if (typeof document === "undefined") {
    return;
  }
  var styles = ".pf-buttons.pf-buttons__secondary {\n  border-radius: 5px;\n}\n\n@media (min-width: 320px) {\n  .pf-radio {\n    font-family: \"Neue Haas Grotesk Text Regular\", \"Helvetica Neue\", helvetica, arial, sans-serif;\n    font-size: 16px;\n    line-height: 24px;\n  }\n}\n@media (min-width: 1024px) {\n  .pf-radio {\n    font-size: 18px;\n    line-height: 28px;\n  }\n}\n.pf-radio.pf-radio__button label > span {\n  font-weight: 700;\n  color: #113b5e;\n  font-size: 14px;\n  line-height: 22px;\n  position: relative;\n}\n@media (min-width: 1024px) {\n  .pf-radio.pf-radio__button label > span {\n    font-size: 16px;\n    line-height: 24px;\n  }\n}\n.pf-radio.pf-radio__button label > span:last-child {\n  margin-left: 14px;\n}\n.pf-radio.pf-radio__button label > span:last-child > p {\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 400;\n  color: #113b5e;\n  margin-top: 0;\n}\n@media (min-width: 1024px) {\n  .pf-radio.pf-radio__button label > span:last-child > p {\n    font-size: 14px;\n    line-height: 18px;\n  }\n}\n\n.pf-radio__supplemental-text {\n  font-weight: 400;\n}\n.pf-radio .pf-radio__propulsion-radio {\n  margin-right: 14px;\n}\n@media (min-width: 1024px) {\n  .pf-radio .pf-radio__propulsion-radio {\n    padding-top: 0;\n  }\n}\n.pf-radio input + span {\n  height: 20px;\n  width: 20px;\n  margin-top: 10px;\n}\n.pf-radio.pf-radio__button.pf-radio__button__no-sub-text input + span {\n  margin-top: 0;\n}";
  var fileName = "secondary__styles_316e4897-b9dd-46cc-ade8-f780b875d481";
  var element = document.querySelector("style[data-sass-component='secondary__styles_316e4897-b9dd-46cc-ade8-f780b875d481']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var BLOCK_CLASS = 'pf-buttons';
var bem = (0, _util.klass)(BLOCK_CLASS);
var SecondaryButton = function SecondaryButton(_ref) {
  var className = _ref.className,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_reactComponents.Button, Object.assign({
    variant: "secondary"
  }, props, {
    className: (0, _util.addClassNames)(className, BLOCK_CLASS, bem('secondary'))
  }));
};
SecondaryButton.propTypes = {
  className: _propTypes.default.string
};
SecondaryButton.defaultProps = {
  className: ''
};
var _default = exports.default = SecondaryButton;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-select-plan/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');